const defaultGet = {
    method: "GET",
    cache: "no-cache",
    credentials: "omit"
}

const defaultPost = {
    method: "POST",
    cache: "no-cache",
    credentials: "omit",
    headers: {
        "Content-Type": "application/json",
    }
}

function withAuthorization(init, jwt) {
    return {
        ...init,
        headers: {
            ...init.headers,
            "Authorization": "Bearer " + jwt
        }
    }
}

function withBody(init, request) {
    return {
        ...init,
        body: JSON.stringify(request)
    }
}

export function fetchUser(jwt) {
    return fetch("/api/portal/userDetails",
        withAuthorization(defaultGet, jwt))
}

export function fetchUserDetails(jwt) {
    return fetch("/api/portal/userDetails?verbose=true",
        withAuthorization(defaultGet, jwt))
}

export function sendChangePasswordRequest(request, jwt) {
    return fetch("/api/portal/changePassword",
        withBody(
            withAuthorization(defaultPost, jwt),
            request)
    )
}

export function fetchServicePoints(jwt) {
    return fetch("/api/portal/servicePoints",
        withAuthorization(defaultGet, jwt))
}

export function fetchServicePointDetails(spId, jwt) {
    return fetch("/api/portal/servicePoints/" + spId,
        withAuthorization(defaultGet, jwt))
}

export function fetchReadings(request, jwt) {

    return fetch("/api/portal/readings/list",
        withBody(
            withAuthorization(defaultPost, jwt),
            request)
    )
}

export function postServicePointAlias(spId, newAlias, jwt) {
    const request = {
        newAlias
    }

    return fetch("/api/portal/servicePoints/" + spId + "/updateAlias",
        withBody(
            withAuthorization(defaultPost, jwt),
            request
        )
    )
}